<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t("reportsGeneration") }}</h3>
      </div>

      <div class="content-container">
        <div class="reports-list-container">
          <div class="reports-filters">
            <input
              #dataSearch
              type="text"
              pInputText
              id="search-input"
              [placeholder]="t('searchReports')"
              class="search-input"
            />
          </div>
          <div class="report-list">
            @for (report of reports; track report.id) {
              <div
                class="report-element"
                pRipple
                [class.active]="currentReportId === report.id"
                (click)="setActiveReport(report)"
              >
                @if (report.icon) {
                  <span class="material-symbols-outlined report-icon">
                    {{ report.icon }}
                  </span>
                }
                <div class="report-details">
                  <p class="report-name">{{ t(report.name) }}</p>
                  @if (report.description) {
                    <p class="report-description">
                      {{ t(report.description) }}
                    </p>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div class="reports-config-container">
          @let report = currentReport;
          @if (report) {
            <p class="current-report-name">{{ t(report.name) }}</p>
            @if (report.config) {
              <form class="config-form" #configForm="ngForm">
                @for (field of report.config; track field.id) {
                  @switch (field.id) {
                    @case ("date") {
                      <p-floatlabel variant="in">
                        <p-datepicker
                          #dateInput="ngModel"
                          inputId="date-input"
                          [name]="field.name ?? field.id"
                          appendTo="body"
                          [(ngModel)]="reportConfig[field.name ?? field.id]"
                          showIcon
                          iconDisplay="input"
                          [required]="field.required ?? false"
                          [maxDate]="today"
                        />
                        <label for="date-input">
                          {{ t(field.name ?? field.id) }}
                          @if (field.required) {
                            <span class="mandatory-label">*</span>
                          }
                        </label>
                      </p-floatlabel>
                    }

                    @case ("startDate") {
                      <p-floatlabel variant="in">
                        <p-datepicker
                          #startDateInput="ngModel"
                          inputId="startDate-input"
                          [name]="field.name ?? field.id"
                          appendTo="body"
                          [(ngModel)]="reportConfig[field.name ?? field.id]"
                          showIcon
                          iconDisplay="input"
                          [required]="field.required ?? false"
                          [maxDate]="today"
                        />
                        <label for="startDate-input">
                          {{ t(field.name ?? field.id) }}
                          @if (field.required) {
                            <span class="mandatory-label">*</span>
                          }
                        </label>
                      </p-floatlabel>
                    }

                    @case ("endDate") {
                      <p-floatlabel variant="in">
                        <p-datepicker
                          #endDateInput="ngModel"
                          inputId="endDate-input"
                          [name]="field.name ?? field.id"
                          appendTo="body"
                          [(ngModel)]="reportConfig[field.name ?? field.id]"
                          showIcon
                          iconDisplay="input"
                          [required]="field.required ?? false"
                          [maxDate]="today"
                        />
                        <label for="endDate-input">
                          {{ t(field.name ?? field.id) }}
                          @if (field.required) {
                            <span class="mandatory-label">*</span>
                          }
                        </label>
                      </p-floatlabel>
                    }

                    @case ("dateRange") {
                      <p-floatlabel variant="in">
                        <p-datepicker
                          #dateRangeInput="ngModel"
                          inputId="dateRange-input"
                          [name]="field.name ?? field.id"
                          appendTo="body"
                          [(ngModel)]="reportConfig[field.name ?? field.id]"
                          showIcon
                          iconDisplay="input"
                          [required]="field.required ?? false"
                          selectionMode="range"
                          [maxDate]="today"
                        />
                        <label for="dateRange-input">
                          {{ t(field.name ?? field.id) }}
                          @if (field.required) {
                            <span class="mandatory-label">*</span>
                          }
                        </label>
                      </p-floatlabel>
                    }
                  }
                }
              </form>

              <p-button
                [label]="t('generateAndDownloadReport')"
                severity="primary"
                icon="pi pi-download"
                [disabled]="!configForm.valid"
                (click)="generateReport()"
              />
            } @else {
              <p class="no-config-info">{{ t("noConfigMessage") }}</p>

              <p-button
                [label]="t('generateAndDownloadReport')"
                severity="primary"
                icon="pi pi-download"
                (click)="generateReport()"
              />
            }
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
